import { Tier } from "./tier.type";
import { containerLoad } from "../shared/container/load-types.const";
import { LclTier } from "./tier-lcl.model";
import { FclTier } from "./tier-fcl.model";
import { ContainerPrices } from "../shared/container/container-prices.model";

export class TierMapper {
  public static map(data: any): Tier {
    if (!data) {
      return;
    }

    if (!data.discriminator) {
      console.trace("no discriminator");
    }

    if (data.discriminator === containerLoad.fcl) {
      return new FclTier(
        data.id,
        data.discriminator,
        data.name,
        data.description,
        new ContainerPrices(data.containers),
      );
    }

    if (
      data.discriminator === containerLoad.lcl ||
      Object.prototype.hasOwnProperty.call(data, "wmPrice")
    ) {
      return new LclTier(
        data.id,
        data.discriminator,
        data.name,
        data.description,
        data.wmPrice,
      );
    }
  }
}
